module.exports = __webpack_public_path__ + "static/media/handtowel.cfcfdbd6.svg";